import { Help } from './help/help'

export const Visual = (() => {
	const init = () => {
		Help.init()
	}

	return {
		init,
	}
})()
